import isNil from 'lodash/isNil';
import omitBy from 'lodash/omitBy';

import { InitialValues, ValidationErrors } from 'forms/types';
import {
  composeValidators,
  getTodayDateTime,
  isGreater,
  isGreaterOrEqual,
  isPresent,
} from 'forms/validators';

import { OccupationFormValues } from '../form/types';

export const validate = ({
  job,
  atLeast30HoursAWeek,
  yearsOfExperience,
  governmentEmployee,
  workFromHomePercentage,
  selfEmployed,
  corporateStructure,
  ownershipStake,
  numberOfEmployees,
  numberOfPartners,
  companyFoundedAt,
  annualIncomeBeforeCompany,
  becameOwnerAt,
  educationLevel,
  individualIncome,
  disabilityInsuranceStatus,
  existingCoverage,
  disabilityInsuranceSource,
  intendToReplace,
  employerPaysPremium,
}: InitialValues<OccupationFormValues>): ValidationErrors<OccupationFormValues> => {
  const errors: ValidationErrors<OccupationFormValues> = {
    job: isPresent(job),
    atLeast30HoursAWeek: isPresent(atLeast30HoursAWeek),
    yearsOfExperience: composeValidators(isPresent, isGreater(0))(yearsOfExperience),
    governmentEmployee: isPresent(governmentEmployee),
    workFromHomePercentage: isPresent(workFromHomePercentage),
    selfEmployed: isPresent(selfEmployed),
    educationLevel: isPresent(educationLevel),
    individualIncome: isPresent(individualIncome),
    disabilityInsuranceStatus: isPresent(disabilityInsuranceStatus),
  };

  if (individualIncome === 0) {
    errors.individualIncome = 'You must have an income to qualify for disability coverage';
  }

  if (selfEmployed) {
    const atLeast0 = composeValidators(isPresent, isGreaterOrEqual(0));

    errors.corporateStructure = isPresent(corporateStructure);
    errors.ownershipStake = isPresent(ownershipStake);
    errors.numberOfEmployees = atLeast0(numberOfEmployees);
    errors.numberOfPartners = atLeast0(numberOfPartners);
    errors.companyFoundedAt = isPresent(companyFoundedAt);
    errors.becameOwnerAt = isPresent(becameOwnerAt);

    if (companyFoundedAt && companyFoundedAt >= getTodayDateTime().year - 1) {
      errors.annualIncomeBeforeCompany = isPresent(annualIncomeBeforeCompany);
    }
  }

  if (disabilityInsuranceStatus) {
    const existingCoverageValidator = composeValidators(isPresent, isGreaterOrEqual(1));

    errors.disabilityInsuranceSource = isPresent(disabilityInsuranceSource);
    errors.intendToReplace = isPresent(intendToReplace);
    errors.existingCoverage = existingCoverageValidator(existingCoverage);

    if (disabilityInsuranceSource === 'employer') {
      errors.employerPaysPremium = isPresent(employerPaysPremium);
    }
  }

  return omitBy(errors, isNil);
};
